import { isFuture } from 'date-fns';
import { useMemo } from 'react';

import { useCurrentUserContext } from '@sorare/core/src/contexts/currentUser';

export const useTradeButtonVisible = (userSlug: string) => {
  const { currentUser } = useCurrentUserContext();
  return useMemo(() => {
    if (!currentUser) {
      return false;
    }

    const { blockedUntil } = currentUser;
    const currentlyBlocked = blockedUntil && isFuture(blockedUntil);
    if (currentlyBlocked) {
      return false;
    }

    if (currentUser.slug === userSlug) return false;

    return true;
  }, [currentUser, userSlug]);
};
